import React from "react"
import {TabbedFacet} from "../tabbedFacet"
import connect from "./connect"
import {SORT, SORT_BY} from "../../../config/constants"

interface SortTabbedFacetProps {
    isFocused?: boolean
    hasSelectedFilters: boolean
    hasSelectedFacet: boolean
    selectedFacetFilters: string
    setSelectedFacet: VoidFunction
}

export const SortTabbedFacet = ({
    isFocused,
    hasSelectedFacet,
    hasSelectedFilters,
    selectedFacetFilters,
    setSelectedFacet,
}: SortTabbedFacetProps) => {
    return (
        <div key={SORT} data-testid="sort-tabbed-facet">
            <TabbedFacet
                facetName={SORT}
                facetDisplayName={SORT_BY}
                hideTopBorder
                hasSelectedFacet={hasSelectedFacet}
                hasSelectedFilters={hasSelectedFilters}
                disabled={false}
                setSelectedFacet={setSelectedFacet}
                selectedFacetFilters={hasSelectedFacet ? undefined : selectedFacetFilters}
                isFocused={isFocused}
            />
        </div>
    )
}

export default connect(SortTabbedFacet)
